import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row }) => <>
  <TableCell size={'small'}><TextCell value={row?.name_translated} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.poi_client_id} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.city_polygon?.name} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.type?.name_translated} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.planned_fee} /></TableCell>
</>

export default React.memo(Row)
